import React from 'react';

/**
 * example.js SyncCardCompact - 동기화 현황 카드
 */
function SyncCardCompact({ label, value, unit, icon, color = '#191f28' }) {
  return (
    <div className="bg-white p-4 rounded-xl border border-[#e0e0e0] shadow-md flex flex-col items-center justify-center group hover:shadow-lg transition-all">
      <div className="flex items-center gap-2 mb-2">
        {icon}
        <span className="text-[18px] font-bold text-[#8b95a1]">{label}</span>
      </div>
      <div className="flex items-baseline gap-1">
        <span className="text-[22px] font-black tracking-tighter" style={{ color }}>
          {value}
        </span>
        <span className="text-[16px] font-bold text-[#4e5968]">{unit}</span>
      </div>
    </div>
  );
}

export default SyncCardCompact;
